// extracted by mini-css-extract-plugin
export default {"root":"CreditManagementPage_root__NLgfC","fieldSection":"CreditManagementPage_fieldSection__-Gg+U"};